import { EarlyAccessRequestModal } from "components/website/modal-variants";
import { createContext, useContext, useState, useCallback, type ReactNode } from "react";

interface EarlyAccessModalContextType {
  openEarlyAccessModal: () => void;
  closeEarlyAccessModal: () => void;
  isEarlyAccessModalOpen: boolean;
}

const EarlyAccessModalContext = createContext<EarlyAccessModalContextType | undefined>(undefined);

interface EarlyAccessModalProviderProps {
  children: ReactNode;
}

export const EarlyAccessModalProvider = ({ children }: EarlyAccessModalProviderProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const openEarlyAccessModal = useCallback(() => {
    setIsOpen(true);
  }, []);

  const closeEarlyAccessModal = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <EarlyAccessModalContext.Provider
      value={{
        openEarlyAccessModal,
        closeEarlyAccessModal,
        isEarlyAccessModalOpen: isOpen,
      }}
    >
      {children}
      <EarlyAccessRequestModal show={isOpen} onClose={closeEarlyAccessModal} />
    </EarlyAccessModalContext.Provider>
  );
};

export const useEarlyAccessModal = (): EarlyAccessModalContextType => {
  const context = useContext(EarlyAccessModalContext);
  if (!context) {
    throw new Error("useEarlyAccessModal must be used within a EarlyAccessModalProvider");
  }
  return context;
};
